module.exports = __webpack_public_path__ + "img/Willing Risk Taker.b3b98491.svg";